<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account")
          i.fa.fa-users
          span.ml-1 {{ $t("title.accounts") }}
      b-breadcrumb-item
        router-link(to="/account/memberTacList")
          i.fa.fa-list-alt
          span.ml-1 {{ $t("title.member_tac_list") }}

  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-question
            b-form-select(v-model="tac_status")
              option(value="active") {{ $t('ui.active') }}
              option(value="pending") {{ $t('ui.pending') }}

        .col-xs-2.col-sm-2.col-md-2.col-lg-6.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="submit"
            variant="success"
            size="sm"
          )

  //- MEMBER
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          i.fa.fa-user
          span {{ $t("title.member") }}
        .card-body.p-1
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.m-0
                b-table#memberTacList.table-sm.table-hover.m-0(
                  show-empty
                  :empty-text="$t('message.no_records')"
                  :no-local-sorting="true"
                  responsive
                  :items="memberTacList"
                  :fields="fields"
                  )
                  template(v-slot:cell(index)="row")
                    .text-center {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .text-left
                      span #[ {{ row.item.account_id }}]
                  template(v-slot:cell(refer_account_id)="row")
                    .text-left
                      span #[ {{ row.item.refer_account_id }}]
                  template(v-slot:cell(status)="row")
                    .text-left
                      span #[ {{ $t("ui." + row.item.status.toLowerCase()) }} ]
                  template(v-slot:cell(activated_date)="row")
                    .text-left(v-if="row.item.activated_date != null")
                      span #[ {{ $moment(row.item.activated_date).format('DD/MM/YYYY hh:mm:ss A') }} ]
                  template(v-slot:cell(action)="row")
                    .text-center(v-if="row.item.status.toLowerCase() == 'pending'")
                      button.btn.btn-danger.btn-sm.activate-button(v-if="!loading" type="button" @click="memberTacActivate(row.item)")
                        span {{ $t("ui.activate") }}
  #end-report.mt-3
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult
  },
  data() {
    return {
      loading: false,
      memberTacList: [],
      account_id: "",
      tac_status: "pending"
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          sortable: false,
          thStyle: {
            width: "220px"
          }
        },
        {
          key: "refer_account_id",
          label: this.$t("ui.refer_account_id"),
          class: "text-left",
          thStyle: {
            width: "220px"
          }
        },
        {
          key: "parent_id",
          label: this.$t("ui.agent_id"),
          class: "text-left",
          thStyle: {
            width: "220px"
          }
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "text-left",
          thStyle: {
            width: "170px"
          }
        },
        {
          key: "activated_date",
          label: this.$t("ui.activated_date"),
          class: "text-left",
          thStyle: {
            width: "170px"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          thStyle: {
            width: "100px"
          }
        }
      ];
    }
  },
  mounted() {
    this.submit();
  },
  methods: {
    memberTacActivate(e) {
      this.$swal({
        title: this.$t("ui.member_tac_activate"),
        text: this.$t("message.member_tac_activate"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var url = xhr.ACCOUNT.memberAgTacActive;
          var args = args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            member_id: e.account_id
          };

          if(e.refer_account_id != null && e.refer_account_id != "") {
            url = xhr.ACCOUNT.memberTacActive;
            args.refer_member_id = e.refer_account_id;
          } else {
            args.agent_id = e.parent_id
          }

          xhr
            .doRequest(args, url)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.submit();
            });
        }
      });
    },
    submit() {
      this.getMemberTacList();
    },
    getMemberTacList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["tac_status"] = this.tac_status;
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.memberTacList)
        .then(res => {
          this.loading = false;
          this.memberTacList = res.data;
          this.$root.$emit("bv::table::refresh", "memberTacList");
        })
        .catch(res => {
          this.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    }
  }
};
</script>
